// extracted by mini-css-extract-plugin
export default {"root":"kxNek","galleryWrapper":"depQl","changing_background":"psjIa","changingBackground":"psjIa"};